import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'configs',
    templateUrl: 'configs.component.html'
})
export class ConfigsDeliveryComponent {
    @Input('group') public configForm: FormGroup;

    @Input('submittedService') submittedService: boolean;

}



// WEBPACK FOOTER //
// ./src/app/components/services-delivery/configs.component.ts